import Message from 'shared_components/message';
import { axiosPhase2API, axiosLabAPI } from 'services/axios';
import HttpCodeMessage from 'shared_components/message_http_status';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchHospitalItems() {
	let HospitalItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: 'listofvalues/hospital',
		});

		const { data } = response;
		HospitalItems = data.RECORDS || [];
	} catch (e) {
		showMessage(e);
	}

	return HospitalItems;
}

export async function createHospitalItems(payload) {
	let HospitalItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			// url: `/lab/`, waiting for APi
			data: payload,
		}).then(response => {
			return {
				data: response.data.RECORDS,
				status: response.status,
			};
		});

		// @ts-ignore
		HospitalItems = await response;
	} catch (e) {
		showMessage(e);
	}
	return HospitalItems;
}

export async function updateHospitalItems(payload) {
	let HospitalItems = [];
	const Hospital_id = payload.locationID;

	try {
		const content = {
			method: API_PUT_METHOD,
			// url: `/lab/`, waiting for APi
			data: payload,
		};

		const response = await axiosLabAPI(content).then(response => {
			return {
				data: response.data.RECORDS,
				status: response.status,
			};
		});
		// @ts-ignore
		HospitalItems = await response;
	} catch (e) {
		showMessage(e);
	}

	return HospitalItems;
}
